<template>
  <section>
    <button
      v-if="park && park.Corporation.code != 'DOCOMO'"
      class="other"
      @click="goToExternalApp"
    >
      公式アプリへ
    </button>
    <button
      v-else-if="
        park && park.Corporation.code == 'DOCOMO' && isNotTargetVersion
      "
      class="disable"
    >
      <b>公式アプリへ</b>
      <br />
      ※アプリを更新して再度お試しください
    </button>
    <button
      v-else-if="
        park && park.Corporation.code == 'DOCOMO' && !isNotTargetVersion
      "
      class="other"
      @click="goToDbsApp"
    >
      公式アプリへ
    </button>
    <div v-else class="blank" />
  </section>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import dbsService from "@/services/dbs";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DbsReservationStatusButtons",
  props: {
    park: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();

    const appVersion = computed(() => store.getters["common/appVersion"]);
    const device = computed(() => store.getters["common/device"]);
    const isNotTargetVersion = ref(false);

    const goToSelectCycle = (type) => {
      dbsService.goToSelectCycle(props.park, type);
    };

    const goToUsing = () => {
      dbsService.goToUsing();
    };

    const goToBooking = () => {
      dbsService.goToBooking();
    };

    const goToExternalApp = () => {
      dbsService.goToExternalApp(props.park);
    };

    const goToDbsApp = () => {
      dbsService.goToDbsApp(props.park);
    };

    const isInAvailableArea = computed(() =>
      dbsService.isInAvailableArea(props.park)
    );

    onMounted(() => {
      console.log("DbsReservationStatusButtons :: onMounted");
      nativeHandlerService.ncAppVersion();
      checkVersion();
    });

    const checkVersion = () => {
      let isLessThanTargetVersion = false;
      switch (device.value) {
        case "IOS":
          isLessThanTargetVersion =
            appVersion.value == "undefined" ||
            convertVersionForCompare(appVersion.value) <
              convertVersionForCompare("2.7.3");
          break;
        case "ANDROID":
          isLessThanTargetVersion =
            appVersion.value == "undefined" ||
            convertVersionForCompare(appVersion.value) <
              convertVersionForCompare("2.7.3");
          break;
        default:
          isLessThanTargetVersion = false;
          break;
      }
      isNotTargetVersion.value = isLessThanTargetVersion;
    };

    watchEffect(() => {
      if (appVersion.value != null) {
        checkVersion();
      }
    });

    // x.x.x(string)のバージョンを、比較用の数値に変換する
    const convertVersionForCompare = (ver) => {
      const verNums = ver.split(".");
      return verNums[0] * 100 + verNums[1] * 10 + verNums[2];
    };

    return {
      goToSelectCycle,
      goToUsing,
      goToBooking,
      goToExternalApp,
      goToDbsApp,
      isInAvailableArea,
      isNotTargetVersion,
    };
  },
};
</script>

<style lang="scss" scoped>
button {
  width: 100%;
  display: block;
  border: none;
  font-size: 13px;
  color: white;
  font-weight: bold;
  height: 42px;
  border-radius: 10px 10px 0px 0px;
}
.blank {
  margin-top: 42px;
}
.flexbox {
  display: flex;
}
.none {
  background: #ffb206;
}
.none:first-child {
  margin-right: 1%;
  border-radius: 10px 0px 0px 0px;
  width: 59.5%;
}
.none:last-child {
  border-radius: 0px 10px 0px 0px;
  width: 39.5%;
}
.started {
  background: #68cb00;
}
.reserved {
  background: #68cb00;
}
.other {
  background: #ffb206;
}
button.disable {
  background-color: #e9e9e9;
  color: #999999;
  height: 64px;
}
</style>
